<template>
  <b-modal
    id="materialevent-modal"
    title="Szczegóły zdarzenia magazynowego"
    size="md"
    @show="onShow"
    hide-footer
  >
    <div v-if="loading">
      <TableSpiner />
    </div>
    <div v-else>
      <h2 v-if="eventInfo.construction">
        {{ eventInfo.construction.name }}
      </h2>
      <h2>
        <label v-if="eventInfo.type === 'wz'" class="badge badge-primary"
          >Wydanie materiału</label
        >
        <label v-else-if="eventInfo.type === 'zw'" class="badge badge-info"
          >Zwrot wydanego materiału</label
        >
        <label v-else-if="eventInfo.type === 'pz'" class="badge badge-success"
          >Przyjęcie materiału</label
        >
        <label v-else-if="eventInfo.type === 'sp'" class="badge badge-success"
        >Sprzedaż materiału</label
        >
        <label
          v-else-if="eventInfo.type === 'zpz'"
          class="badge badge-secondary"
          >Zwrot przyjętego materiału</label
        >
      </h2>
      <p class="material-header">
        <span>
          Data zdarzenia :
          {{ eventInfo.issue_date | date }}
        </span>
      </p>
      <div class="material-summary">
        <div>
          <p>Łączna ilość materiałów:</p>
          <p>{{ eventInfo.quantity }}</p>
        </div>
        <div v-if="getRole !== 'subcontractor'">
          <p>Całkowita wartość:</p>
          <p>
            {{ eventInfo.cost.toFixed(2) }}
            <small>{{getMainBaseCurrency}}</small>
          </p>
        </div>
      </div>
      <div
        class="material"
        v-for="(material, index) in eventInfo.materials"
        :key="'me' + index"
      >
        <div class="image">
          <img v-if="material.image" :src="material.image" />
          <img
            v-else
            src="../../assets/image/default_material_img.svg"
            alt="deafult material image"
          />
        </div>
        <div class="details">
          <div class="name">
            <p>{{ material.name }}</p>
            <p>{{ material.quantity }} szt</p>
          </div>
          <div class="cost" v-if="getRole !== 'subcontractor'">
            <p>
              {{ material.price.toFixed(2) }}
              <small>{{getMainBaseCurrency}}</small>/szt
            </p>
            <p>
              Łącznie: {{ material.cost.toFixed(2) }}
              <small>{{getMainBaseCurrency}}</small>
            </p>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { WarehouseEvents } from "@/services/warehouse.service";
import TableSpiner from "@/components/TableSpiner";
import {formatDateTime} from "@/services/helpers";

export default {
  name: "ModalMaterialsEvent",
  components: { TableSpiner },
  props: {
    event: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters("company", ["getMainBaseCurrency"]),
    ...mapGetters("user", ["getRole"]),
  },
  data() {
    return {
      loading: true,
      eventInfo: {},
    };
  },
  filters: {
    date(value) {
      return formatDateTime(value, "YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    onShow() {
      if (this.eventInfo.id && this.event.id === this.eventInfo.id) {
        this.loading = false;
        return;
      }
      this.loading = true;
      WarehouseEvents.event(this.event.id)
        .then((data) => {
          this.eventInfo = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
